import { render, staticRenderFns } from "./ReadAndPrint.vue?vue&type=template&id=f4297f26&"
import script from "./ReadAndPrint.vue?vue&type=script&lang=ts&"
export * from "./ReadAndPrint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports